import { useEffect, useMemo, useState } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { getSidebarKeys } from '@layouts/main/sider/helpers.ts';

import { SiderLogo } from '../logo';
import SiderMenu from '../menu';
import { SiderContent, SiderLayoutWrapper, SiderToggleIcon, SiderTriggerIconWrapper } from './styled.ts';

const getPathnameAsKey = (pathname: string, sidebarKeys: ReturnType<typeof getSidebarKeys>): string => {
    const result = Object.entries(sidebarKeys).find(([, value]) => pathname.includes(`/${value}`));

    if (result) {
        const [pathKey] = result;
        return sidebarKeys[pathKey as keyof typeof sidebarKeys];
    }

    return pathname.substring(pathname.lastIndexOf('/') + 1);
};

const MainSider = () => {
    const SIDEBAR_KEYS = useMemo(() => getSidebarKeys(), []);
    const [siderCollapsed, setSiderCollapsed] = useState(true);
    const [activeKey, setActiveKey] = useState('');

    const location = useLocation();

    // helper function to check if the current pathname exactly matches a given route key
    const isAtRoute = (route: string, pathname: string) => !!matchPath({ path: `/${route}`, end: true }, pathname);
    const isLearningLandingPage = isAtRoute(SIDEBAR_KEYS.LEARNING, location.pathname);

    // put keys in order what you want to see in sidebar
    // const topSiderBarKeysOne = [
    //     SIDEBAR_KEYS.ASSESSMENT,
    //     SIDEBAR_KEYS.LEARNING,
    //     SIDEBAR_KEYS.PROGRESS,
    //     SIDEBAR_KEYS.SURVEY,
    // ];

    const topSiderBarKeysOneDemo = [
        SIDEBAR_KEYS.LEARNING,
        SIDEBAR_KEYS.ASSESSMENT,
        SIDEBAR_KEYS.ASK,
        SIDEBAR_KEYS.PERFORM,
    ];

    // const topSiderBarKeysTwo = [SIDEBAR_KEYS.ASK, SIDEBAR_KEYS.PERFORM];

    const bottomSiderBarKeys = [SIDEBAR_KEYS.ADMIN, SIDEBAR_KEYS.SETTINGS, SIDEBAR_KEYS.HELP_CENTER];

    useEffect(() => {
        const pathnameAsKey = getPathnameAsKey(location.pathname, SIDEBAR_KEYS);
        setActiveKey(pathnameAsKey);
        setSiderCollapsed(!isLearningLandingPage);
    }, [SIDEBAR_KEYS, location.pathname, isLearningLandingPage]);

    return (
        <>
            <SiderLayoutWrapper trigger={null} collapsed={siderCollapsed} collapsedWidth={74} collapsible>
                <SiderContent>
                    <SiderMenu
                        position="top"
                        sidebarKeys={topSiderBarKeysOneDemo}
                        collapsed={siderCollapsed}
                        selectedKey={activeKey}
                        onSelect={setActiveKey}
                    />
                    {/*<BaseDividerWrapper />*/}
                    {/*<SiderMenu*/}
                    {/*    position="top"*/}
                    {/*    sidebarKeys={topSiderBarKeysTwo}*/}
                    {/*    collapsed={siderCollapsed}*/}
                    {/*    selectedKey={activeKey}*/}
                    {/*    onSelect={setActiveKey}*/}
                    {/*/>*/}
                    <SiderMenu
                        position="bottom"
                        sidebarKeys={bottomSiderBarKeys}
                        collapsed={siderCollapsed}
                        selectedKey={activeKey}
                        onSelect={setActiveKey}
                    />
                    <SiderLogo collapsed={siderCollapsed} />
                </SiderContent>
            </SiderLayoutWrapper>
            <SiderTriggerIconWrapper onClick={() => setSiderCollapsed(!siderCollapsed)}>
                <SiderToggleIcon $rotated={siderCollapsed} />
            </SiderTriggerIconWrapper>
        </>
    );
};

export default MainSider;
